import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 2.5a2.81 2.81 0 0 0-2.651 1.875H6.25c-1.034 0-1.875.84-1.875 1.875v9.375c0 1.034.84 1.875 1.875 1.875h7.5c1.034 0 1.875-.84 1.875-1.875V6.25c0-1.034-.84-1.875-1.875-1.875h-1.099A2.81 2.81 0 0 0 10 2.5m0 1.875a.937.937 0 1 1 0 1.875.937.937 0 0 1 0-1.875m3.31 6.123-3.75 3.75a.7.7 0 0 1-.993 0L6.69 12.373a.703.703 0 0 1 .993-.993l1.378 1.377 3.255-3.255a.703.703 0 0 1 .993.993z"
    }, null, -1)
  ]))]))
}
export default { render: render }